import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { setMainPage } from '../actions/app';
import { getPageFromPath, getPageTitle } from '../config/routes';

/**
 * RouteSync Component
 *
 * Synchronizes URL changes with Redux state by calling setMainPage()
 * which triggers all the necessary side effects:
 * - Unity scene transitions
 * - Graphics syncing
 * - Modal/overlay management
 * - Middleware reactions (GDL, timers, etc.)
 *
 * Also updates the document title for WCAG compliance.
 *
 * This component has no visual output - it only handles the sync logic.
 */
const RouteSync = ({ currentPage, appName, gotoPage }) => {
  const location = useLocation();

  // Sync URL changes to Redux state
  useEffect(() => {
    // Get the page constant from the current URL path
    const pageFromUrl = getPageFromPath(location.pathname);

    // Only dispatch if the URL page differs from Redux state
    // This prevents infinite loops and unnecessary dispatches
    if (pageFromUrl !== currentPage) {
      gotoPage(pageFromUrl);
    }
  }, [location.pathname, currentPage, gotoPage]);

  // Update document title when page changes
  useEffect(() => {
    document.title = getPageTitle(currentPage, appName);
  }, [currentPage, appName]);

  return null; // This component renders nothing
};

const mapStateToProps = (state) => ({
  currentPage: state.app.page,
  appName: state.app.name || 'WhiteBox Learning',
});

const mapDispatchToProps = (dispatch) => ({
  gotoPage: (page) => dispatch(setMainPage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteSync);
